export const transactionData = [
    {
        id:'1',
        accountitle:"Shujat Ali",
        accountnumber:'0000-0000-0000',
        amount:'2500', 
        date:'13/01/2025',
    },
    {
        id:'2',
        accountitle:"Azeem Ali",
        accountnumber:'0000-0000-0000',
        amount:'2500', 
        date:'13/01/2025',
    },
    {
        id:'3',
        accountitle:"Abdullah Ali",
        accountnumber:'0000-0000-0000',
        amount:'2500', 
        date:'13/01/2025',
    },
]